var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "over-delivery-part-dialog",
      attrs: {
        visible: _vm.dialogVisible,
        title: "可超交料号",
        width: "80%",
        top: "5vh",
        "append-to-body": "",
        "destroy-on-close": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _vm.$hasBtnPermiss("OverDeliveryPart/SaveData").isShow
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v("确定")]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "container--top" },
          [
            _c("ConfirmTable", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.confirmTableLoading,
                  expression: "confirmTableLoading"
                }
              ],
              ref: "confirmTable",
              attrs: { "data-source": _vm.confirmData },
              on: {
                "update:dataSource": function($event) {
                  _vm.confirmData = $event
                },
                "update:data-source": function($event) {
                  _vm.confirmData = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "container--bottom" },
          [
            _c(
              "div",
              { staticClass: "control-buttons" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function($event) {
                        _vm.spareTableVisible = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.spareTableVisible = true
                      }
                    }
                  },
                  [_vm._v("新增")]
                )
              ],
              1
            ),
            _vm.spareTableVisible
              ? _c("SpareTable", {
                  on: { "cell-insert-click": _vm.handleCellInsertClick }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }